import template from './template.v2.json' with { type: "json" };
import packageInfo from '../package.json' with { type: "json" };
import { bigIntToVmNumber, CashAddressNetworkPrefix, createVirtualMachineBch, encodeDataPush, hash256, hexToBin, lockingBytecodeToCashAddress, } from "@bitauth/libauth";
import { getScriptHash } from "@unspent/tau";
import Future from './auth.js';
export class Coupon {
    static USER_AGENT = packageInfo.name;
    static tokenAware = false;
    static template = template;
    static vm = createVirtualMachineBch();
    static compiler = Future.compiler;
    amount = 1000000;
    lock = new Uint8Array(0);
    static unlockingScript = "00cc00c694a16900c788c08bc39c";
    /**
     * Return the scripthash for a Coupon
     *
     *
     * @param amount - the threshold amount (sats) to redeem coupon
     * @param lock - the vault locking bytecode
     * @param reversed - whether to return the string in reversed (default: true)
     */
    static getScriptHash(amount, lock, reversed = true) {
        return getScriptHash(this.getLockingBytecode(amount, lock), reversed);
    }
    /**
     * Return the address for a Coupon
     *
     *
     * @param amount - the threshold amount (sats) to redeem coupon
     * @param lock - the vault locking bytecode
     * @param network - the network prefix
     */
    static getAddress(amount, lock, network = CashAddressNetworkPrefix.mainnet) {
        let lockingBytecode = this.getLockingBytecode(amount, lock);
        let result = lockingBytecodeToCashAddress({ bytecode: lockingBytecode, prefix: network, tokenSupport: false });
        if (typeof result === 'string')
            throw (result);
        return result.address;
    }
    /**
      * Return the unlockingBytecode for a Coupon
      *
      *
      * @param amount - the threshold amount (sats) to redeem coupon
      * @param lock - the vault locking bytecode
      */
    static getUnlockingBytecode(amount, lock) {
        const amountVm = encodeDataPush(bigIntToVmNumber(BigInt(amount)));
        const lockVm = encodeDataPush(lock);
        const unlockingScript = hexToBin(this.unlockingScript);
        return new Uint8Array([
            ...lockVm,
            ...amountVm,
            ...unlockingScript
        ]);
    }
    /**
     * Return the lockingBytecode for a Coupon
     *
     *
     * @param amount - the threshold amount (sats) to redeem coupon
     * @param lock - the Vault locking bytecode
     */
    static getLockingBytecode(amount, lock) {
        return new Uint8Array([
            ...hexToBin("aa20"),
            ...hash256(this.getUnlockingBytecode(amount, lock)),
            ...hexToBin("87")
        ]);
    }
}
//# sourceMappingURL=coupon.js.map